// 导出该模块state、actions、mutations
import actions from './actions'
import relationUser from './metaData/relationUser'
export default {
  state: relationUser,
  actions
}
